import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from "@angular/forms";
import { Option, optionMatchesControl } from "@recore-solutions/nstar-lib";
import { Observable } from "rxjs";
import { first, map } from "rxjs/operators";

function countDecimals(value: number): number {
	if (Math.floor(value) === value) {
		return 0;
	}
	const afterDecimal = value?.toString().split(".");
	return !!afterDecimal ? afterDecimal[1]?.length || 0 : 0;
}

export function ScaleValidator(scale: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors => {
		return !control
			? null
			: !control.value
			? null
			: countDecimals(control.value) <= scale
			? null
			: { scaleValidator: { scale } };
	};
}

export function MinimumArrayLengthValidator(minimumLength: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors => {
		return !!control &&
			!!control.value &&
			Array.isArray(control.value) &&
			control.value.length >= minimumLength
			? null
			: { MinimumArrayLengthValidator: { minimumLength, actualLength: control?.value?.length } };
	};
}

export function MaximumArrayLengthValidator(maximumLength: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors => {
		return !control
			? null
			: !control.value
			? null
			: !Array.isArray(control.value)
			? null
			: control.value.length <= maximumLength
			? null
			: { maximumArrayLengthValidator: { maximumLength, actualLength: control?.value?.length } };
	};
}

export function IsInDynamicOptionsValidator(option$: Observable<Option[]>): AsyncValidatorFn {
	return (control: AbstractControl): Observable<ValidationErrors> => {
		return option$.pipe(
			map((options) =>
				!control.value || !!options.find(optionMatchesControl(control))
					? null
					: { isInDynamicOptionsValidator: true }
			),
			first()
		);
	};
}

export function blacklistedValidator(blacklist: string[]): ValidatorFn {
	return (control: AbstractControl): ValidationErrors => {
		if (!control || !control.value) {
			return null;
		}
		const blacklistedUrl = isBlackListed(control.value, blacklist);
		return !!blacklistedUrl ? { blacklistedValidator: blacklistedUrl + " is not allowed." } : null;
	};
}

function isBlackListed(value: string, blacklist: string[]): string {
	const url = value.toLowerCase();
	for (const blacklisted of blacklist) {
		if (url.indexOf(blacklisted.toLowerCase()) >= 0) {
			return blacklisted;
		}
	}
	return null;
}
